import Notify from './Notify';

export const NotifyNetworkError = (message: string) => Notify('Uh-oh!', message, 'danger');
